import { stringify } from "../../utils/json.js";
import { track } from "./index.js";
/**
 * @internal
 */
export async function trackTransaction(args) {
    return trackTransactionEvent({
        ...args,
        action: "transaction:sent",
    });
}
/**
 * @internal
 */
function trackTransactionEvent(args) {
    return track({
        client: args.client,
        ecosystem: args.ecosystem,
        data: {
            action: args.action,
            clientId: args.client.clientId,
            chainId: args.chainId,
            transactionHash: args.transactionHash,
            walletAddress: args.walletAddress,
            walletType: args.walletType,
            contractAddress: args.contractAddress,
            functionName: args.functionName,
            gasPrice: args.gasPrice,
            errorCode: stringify(args.error),
        },
    });
}
//# sourceMappingURL=transaction.js.map